import { chaveDoDiaEmUtc, formatDataPrazoLongo, formatDataPrazoSemAno } from '@/shared/formatters';
import { diasAte } from '@/shared/utils/dateUtils';

export type PrazoPendenciaTom = 'vencido' | 'urgente' | 'normal';

interface PrazoPendencia {
  tom: PrazoPendenciaTom;
  diasRestantes: number | null;
  chipRotulo: string;
  detalheRotulo: string;
}

const DIAS_URGENTE = 3;

const SEM_PRAZO_LEGIVEL: PrazoPendencia = {
  tom: 'normal',
  diasRestantes: null,
  chipRotulo: 'Prazo em aberto',
  detalheRotulo: 'Prazo em aberto',
};

const contagemRotulo = (diasRestantes: number): string => {
  if (diasRestantes === 0) return 'Vence hoje';
  if (diasRestantes === 1) return 'Vence amanhã';
  return `Vence em ${diasRestantes} dias`;
};

const atrasoRotulo = (diasRestantes: number): string => {
  const diasVencidos = Math.abs(diasRestantes);
  if (diasVencidos === 1) return 'Venceu ontem';
  return `Venceu há ${diasVencidos} dias`;
};

export const derivarPrazoPendencia = (prazoLimiteIso: string, agoraIso: string): PrazoPendencia => {
  const chaveDoPrazo = chaveDoDiaEmUtc(prazoLimiteIso);
  const diasRestantes = diasAte(chaveDoPrazo, new Date(agoraIso));
  const dataCompleta = formatDataPrazoLongo(chaveDoPrazo);

  if (diasRestantes === null || dataCompleta === '') return SEM_PRAZO_LEGIVEL;

  if (diasRestantes < 0) {
    return {
      tom: 'vencido',
      diasRestantes,
      chipRotulo: atrasoRotulo(diasRestantes),
      detalheRotulo: `${atrasoRotulo(diasRestantes)} · o prazo era ${dataCompleta}`,
    };
  }

  if (diasRestantes <= DIAS_URGENTE) {
    return {
      tom: 'urgente',
      diasRestantes,
      chipRotulo: contagemRotulo(diasRestantes),
      detalheRotulo: `${contagemRotulo(diasRestantes)} · até ${dataCompleta}`,
    };
  }

  return {
    tom: 'normal',
    diasRestantes,
    chipRotulo: `Até ${formatDataPrazoSemAno(chaveDoPrazo)}`,
    detalheRotulo: `Até ${dataCompleta}`,
  };
};
